import ApiService from "@/utils/api.service";

export default {
    request(context, request) {
        return new Promise((resolve, reject) => {
            context.dispatch("app/setLoading", true, { root: true });
            ApiService.post("moneyRequest", request)
                .then(({ data }) => {

                    context.dispatch("auth/updateMoneyRequest", data, { root: true });

                    resolve(data);
                }).catch(({ response }) => {
                    reject(response.data);
                }).finally(() => {
                    context.dispatch("app/setLoading", false, { root: true })
                })
        });
    },
    list(context) {
        return new Promise(resolve => {
            context.dispatch("app/setLoading", true, { root: true });
            ApiService.get("moneyRequest")
                .then(({ data }) => {
                    context.commit("setList", data);
                    resolve(data);
                })
                .finally(() => {
                    context.dispatch("app/setLoading", false, { root: true });
                });
        });
    },

    accept(context, requestId) {
        return new Promise((resolve, reject) => {
            context.dispatch("app/setLoading", true, { root: true });
            ApiService.put("moneyRequest/" + requestId, { status: 'accept' })
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response.data);
                })
                .finally(() => {
                    context.dispatch("app/setLoading", false, { root: true });
                });
        });
    },
    decline(context, requestId) {
        return new Promise((resolve, reject) => {
            context.dispatch("app/setLoading", true, { root: true });
            ApiService.put("moneyRequest/" + requestId, { status: 'decline' })
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response.data);
                })
                .finally(() => {
                    context.dispatch("app/setLoading", false, { root: true });
                });
        });
    },

}